import { AnalysisFileType } from "../../../types/analysisFileTypes";
import GenericAnalysisFilesPage from "./GenericAnalysisFilesPage";


export default function CompanyPensionAnalysisFilesPage() {
    return <GenericAnalysisFilesPage
        fileType={AnalysisFileType.CompanyPensionAnalysisFile}
        title={"analysisPage.companyPension.title"}
    />
}